import './App.css'
import Generator from './app/Generator'
import Preview from './app/Preview'

function App() {
    return (
        <div className="container">
            <div className="generator">
                <Generator />
            </div>
            <div className="preview">
                <Preview />
            </div>
        </div>
    )
}

export default App
